import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { Phone, Mail, MapPin, Clock, MessageSquare } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const openWhatsApp = () => {
    const message = encodeURIComponent(
      `Hola! Me gustaría obtener más información sobre los servicios de mantenimiento de motocicletas en YT MotoCenter.`
    );
    const phoneNumber = '50685834427';
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <footer className="footer-custom text-white pt-5">
      <Container>
        <Row className="mb-4">
          {/* Company Info */}
          <Col md={6} lg={12} className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <Image
                src="https://customer-assets.emergentagent.com/job_biketechpro/artifacts/9yrxeouv_Image%20%2839%29.jpeg"
                alt="YT MotoCenter Logo"
                roundedCircle
                width={50}
                height={50}
                className="border border-warning me-2"
              />
              <div>
                <h5 className="mb-0">YT MotoCenter</h5>
                <small className="text-muted">Taller de Motocicletas</small>
              </div>
            </div>
            <p className="small ">
              Somos especialistas en mantenimiento y reparación de motocicletas con más de 10 años de experiencia en Costa Rica. Tu moto en las mejores manos.
            </p>
          </Col>

          {/* Services */}
          <Col md={6} lg={3} className="mb-4">
            <h6 className="text-warning">Servicios</h6>
            <ul className="list-unstyled small">
              <li className="mb-1">Mantenimiento Preventivo</li>
              <li className="mb-1">Mantenimiento Correctivo</li>
              <li className="mb-1">Revisión de Frenos</li>
              <li className="mb-1">Cambio de Aceite</li>
              <li className="mb-1">Ajuste de Cadena</li>
              <li className="mb-1">Revisión Eléctrica</li>
            </ul>
          </Col>

          {/* Contact Info */}
          <Col md={6} lg={3} className="mb-4">
            <h6 className="text-warning">Contacto</h6>
            <div className="small">
              <div className="d-flex align-items-center mb-2">
                <Phone className="custom-icons me-2" size={16} /> 8583-4427
              </div>
              <div className="d-flex align-items-center mb-2">
                <Mail className="custom-icons me-2" size={16} /> ytmotocenter@gmail.com
              </div>
              <div className="d-flex align-items-start mb-2">
                <MapPin className="custom-icons me-2" size={16} />
                <div>
                  San José, Moravia<br />
                  San Vicente, Costa Rica
                </div>
              </div>
            </div>
          </Col>

          {/* Hours */}
          <Col md={6} lg={6} className="mb-4">
            <h6 className="text-warning">Horarios</h6>
            <div className="small">
              <div className="d-flex align-items-center mb-2">
                <Clock className="me-2 custom-icons" size={16} />
                <div>
                  Lunes - Viernes<br />
                  <p className="small ">8:00 AM - 5:00 PM</p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-2">
                <Clock className="me-2 custom-icons" size={16} />
                <div>
                  Sábados<br />
                  <p className="small ">8:00 AM - 4:00 PM</p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-2">
                <Clock className="me-2 custom-icons" size={16} />
                <div>
                  Domingos<br />
                  <p className="small ">Cerrado</p>
                </div>
              </div>
              <div className='pt-4 border-top'>
                <Button
                  onClick={openWhatsApp}
                  className="whatsapp-button w-100 d-flex justify-content-center align-items-center gap-2"
                >
                  <MessageSquare size={18} />
                  Contactar por WhatsApp
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        {/* Bottom Bar */}
        <Row className="InfoDev border-top pt-3">
          <Col md={6} className="text-li small mb-2 mb-md-0">
            © {currentYear} YT TechServices. Todos los derechos reservados.
          </Col>
          <Col md={6} className="d-flex justify-content-md-end gap-3">
            <a href="/politica-privacidad" className="InfoDev text-decoration-none">
              Política de Privacidad
            </a>
            <a href="/terminos-servicio" className="InfoDev text-decoration-none">
              Términos de Servicio
            </a>


          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
